<button (click)="addRow()">Add Row</button>
<input type="text" placeholder="Column Name" [(ngModel)]="newColumnName" />
<button (click)="addColumn()">Add Column</button>
<table>
    <thead>
        <tr>
            <th *ngFor="let key of arrayKeys(sampleObject)">{{ key }}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of sampleObject">
            <td *ngFor="let key of arrayKeys(sampleObject)">
                <input type="text" [value]="getValues(row, key) || ''" (change)="updateObjectValue(row, key, $event.target.value)" />
            </td>
        </tr>
    </tbody>
</table>
csv:<input type="file" (change)="onFileSelected($event)" accept=".csv" />
json: <input type="file" (change)="onJsonFileSelected($event)" accept=".json" />
<br />
<button (click)="downloadAsCSV()">Download as CSV</button>
<button (click)="downloadAsJSON()">Download as JSON</button>